import { freePlan } from '../../../../../common/mocks/freePlan'

const useHeaderLabel = (
  isActiveTrial: any,
  planOptions: any,
  isFreePlan: any,
  isSmallScreen: boolean,
) => {
  if (isActiveTrial) {
    return { headerLabel: isSmallScreen ? 'Confirm' : 'Confirm Plan' }
  }

  const currentPlan = isFreePlan
    ? freePlan
    : planOptions.find((option: any) => option.isCurrentPlan)
  if (currentPlan.planId === 'free') {
    return { headerLabel: isSmallScreen ? 'Upgrade' : 'Upgrade from Free' }
  }

  return {
    headerLabel: isSmallScreen ? 'Change' : 'Change my plan',
  }
}

export default useHeaderLabel
